<template>
  <section class="odm-hero-section">
    <div class="odm-hero-bg">
      <img src="../../assets/solution/odm.jpg" alt="ODM" />
    </div>
    <div class="odm-hero-content">
      <div class="odm-hero-title" v-html="t('odm.odmCarousel.title')"></div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
</script>

<style scoped>
.odm-hero-section {
  width: 100%;
  position: relative;
}

.odm-hero-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.odm-hero-bg {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.odm-hero-bg img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.odm-hero-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.odm-hero-title {
  width: 100%;
  font-size: 2.2rem;
  font-weight: bold;
  text-align: center;
  border-radius: 8px;
  padding: 40px 0;
  color: rgb(18, 18, 18);
  /* background-color: #fff; */
  background-image: url("../../assets/solution/odm_title.png");
  background-size: 100% auto;
  background-repeat: no-repeat; 
  background-position: center;
  background-origin: padding-box; 
  opacity: 1.0;
  letter-spacing: 10px;
}

/* 大屏幕设备 (1400px 以上) */
@media screen and (min-width: 1400px) {
  .odm-hero-title {
    font-size: 2.7rem;
    padding: 40px 0;
  }
}

/* 笔记本电脑 */
@media screen and (max-width: 1399px) {
  .odm-hero-title {
    font-size: 2.2rem;
    padding: 30px 0;
  }
}

/* 平板设备 */
@media screen and (max-width: 991px) {
  .odm-hero-title {
    font-size: 1.8rem;
    padding: 20px 0;
  }
}

/* 手机设备 */
@media screen and (max-width: 767px) {
  .odm-hero-title {
    font-size: 1.4rem;
    padding: 10px 0;
  }
}
</style>